import { channelTypesBuilder, ChannelTypesModel } from "shared/models/ChannelTyoes";
import { httpTrafficLights } from "../http/httpClient";

export const channelService = () => {
    const getAll = async (
        page: number | null,
        page_size: number | null,
        sort: string | null,
        dir: string | null,
    ): Promise<ChannelTypesModel> => {
        const params = new URLSearchParams();
        if (page !== null) params.append('page', String(page));
        if (page_size !== null) params.append('page_size', String(page_size));
        if (sort !== null) params.append('sort', String(sort));
        if (dir !== null) params.append('dir', String(dir));
        const res = await httpTrafficLights.get(`channels?${params.toString()}`);
        return {
            ...res,
            rows: res.rows.map(channelTypesBuilder.fromBackEnd),
        }
    }
    return {
        getAll,
    }
}